
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Component Libraries`}</h3>
    <ul>
      <li parentName="ul">{`Added a new collapsible App Bar component for `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/angular/?path=/info/components-app-bar--readme"
        }}>{`Angular`}</a>{` and `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react/?path=/info/components-app-bar--get-read-me-story"
        }}>{`React`}</a>{` and a Collapsible Header Layout for `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react-native/?path=/info/components-documentation--collapsible-header-layout"
        }}>{`React Native`}</a>{`.`}</li>
      <li parentName="ul">{`Added Three Liner component that supports three stylized lines of text for use in App Bar for `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/angular/?path=/info/components-three-liner--readme"
        }}>{`Angular`}</a>{` and `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react/?path=/info/components-three-liner--get-read-me-story"
        }}>{`React`}</a>{`.`}</li>
      <li parentName="ul">{`Responsive updates to User Menu component to open a bottom sheet on mobile.`}</li>
      <li parentName="ul">{`Updated Angular library to build with Angular 11.`}</li>
    </ul>
    <h3>{`Component Sticker Sheet`}</h3>
    <ul>
      <li parentName="ul">{`Updated Figma `}<a parentName="li" {...{
          "href": "https://www.figma.com/community/file/852558784352181868"
        }}>{`Component Sticker Sheet`}</a>{` to include dark theme variants for all components`}</li>
      <li parentName="ul">{`Added latest icons from Material Design and PX Blue.`}</li>
      <li parentName="ul">{`Released `}<a parentName="li" {...{
          "href": "https://www.figma.com/community/plugin/971482182464094790"
        }}>{`Variant Switcher`}</a>{` plugin that allows you to convert your designs between light and dark themes with one click.`}</li>
    </ul>
    <h3>{`Documentation Site`}</h3>
    <ul>
      <li parentName="ul">{`Added a dedicated `}<a parentName="li" {...{
          "href": "/resources/designer"
        }}>{`Designer Resources`}</a>{` page.`}</li>
      <li parentName="ul">{`Added ability to download PNG versions of all icons in various size / color combinations on the `}<a parentName="li" {...{
          "href": "/style/iconography"
        }}>{`Iconography`}</a>{` page.`}</li>
      <li parentName="ul">{`Updated `}<a parentName="li" {...{
          "href": "/patterns/overlay"
        }}>{`Overlay`}</a>{` pattern to include recommended libraries for Expandable Bottom Sheets.`}</li>
    </ul>
    <h3>{`Re-usable Authentication Workflows`}</h3>
    <ul>
      <li parentName="ul">{`Added full internationalization capabilities with built-in support for English, French, Spanish, and Simplified Chinese.`}</li>
      <li parentName="ul">{`Updated support for using dark theme.`}</li>
      <li parentName="ul">{`Updated styles to be more responsive across different screen sizes.`}</li>
      <li parentName="ul">{`Added support for custom Welcome & Success screens and assorted custom content injection.`}</li>
    </ul>
    <h3>{`PX Blue CLI`}</h3>
    <ul>
      <li parentName="ul">{`Added support for choosing templates to start your Ionic projects.`}</li>
    </ul>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes & minor updates`}</li>
      <li parentName="ul">{`Dropped support for Internet Explorer 11 in line with Microsoft retiring the browser.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;